import tw from 'twin.macro'
import { styled } from '@mui/material/styles'
import { MuiTelInput } from 'mui-tel-input'

export const PhoneField: any = styled(MuiTelInput)`
  & .MuiInputBase-root {
    ${tw`rounded-lg pl-2`}
  }

  & label.Mui-focused {
    ${tw`text-primary-600`}
  }

  & .MuiInputBase-root.Mui-focused fieldset {
    ${tw`border-primary-600`}
  }
`
